import { memo, ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	header: ReactNode;
	children: ReactNode;
}

const BorderedBox = ({ className, header, children }: Props) => {
	return (
		<div className={className}>
			<Header>{header}</Header>

			<Content>{children}</Content>
		</div>
	);
};

const Header = styled.div`
	padding: 1rem;
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
`;
const Content = styled.div`
	padding: 1rem;
`;

const Memoized = memo(BorderedBox);
const Styled = styled(Memoized)`
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.5rem;
`;

export { Styled as BorderedBox };
